import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";

const SuccessfulPurchase = styled(({className, onClose}) => {
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>

                <ModalHeader>Success!</ModalHeader>
                <ModalCloseButton />

                <ModalBody pb={6} className={className}>
                    <p>We've received your payment - your purchase should go through any moment now.</p>
                </ModalBody>

                <ModalFooter>
                    <Button variant="blue" mr={3} onClick={onClose}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})``;

export default SuccessfulPurchase;
